import {TIMEOUT_STRING, DARK_MODE} from "../util/Constants";

const postMessagePromises = {};
function generateGuid(){
    /**
     * @return {string}
     */
    function S4() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    }
    return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0,3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
}

/**
 * This method will get the feature flag from AppConfig
 * @param {List<String>} features
 * @returns
 */
export async function getFeaturesFromParent(features) {
    return await postMessagePromised(window.parent, {
        method: 'getFeatureStatus',
        args: {features}
    }, '*')
}

function postMessagePromised(targetWindow, message, targetOrigin, timeout) {
    const newGuid = generateGuid();
    message.guid = newGuid;
    postMessagePromises[newGuid] = {};
    postMessagePromises[newGuid]['promise'] = new Promise(function (resolve, reject) {
        postMessagePromises[newGuid]['resolve'] = resolve;
        postMessagePromises[newGuid]['reject'] = reject;
        targetWindow.postMessage(message, targetOrigin);
        if (timeout) {
            setTimeout(() => {
                postMessagePromises[newGuid].resolve(TIMEOUT_STRING);
            },timeout);
        }
    });
    return postMessagePromises[newGuid].promise;
}

var setCurrentDarkMode = () => {};
export function setDarkModeStateListener(darkModeStateListener) {
  setCurrentDarkMode = darkModeStateListener;
}

export async function getDarkModeStatus() {
    return await postMessagePromised(
      window.parent,
      {
        method: "getDarkModeStatus",
        args: {},
      },
      "*",
    );
}

export function publishClientSideMetrics(args) {
    window.parent.postMessage({
        method: 'publishClientSideMetrics',
        args: args
    }, "*");
}

export async function getCycleDataFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getCycleDataFromParent',
        args: {}
    }, '*');
}

export async function getNodeCapability() {
    return await postMessagePromised(window.parent, {
        method: 'getNodeCapability',
        args: {}
    }, '*');
}

export async function getAPIGatewayDataFromParent(args) {
    return await postMessagePromised(window.parent, {
        method: 'getAPIGatewayDataFromParent',
        args: args
    }, '*');
}

export async function getOverviewData(args) {
    return await postMessagePromised(window.parent, {
        method: 'getOverviewData',
        args: args
    }, '*');
}

export async function getDocumentURL() {
    return await postMessagePromised(window.parent, {
        method: 'getDocumentURL',
        args: {}
    }, '*');
}

export async function getLocaleFromParent() {
    const response = await postMessagePromised(window.parent, {
        method: 'getLocale',
        args: {}
    }, '*',200);
    if (TIMEOUT_STRING !== response) {
        return JSON.parse(response.locale);
    }
}

export function setSelectedCycle(selectedCycle) {
    window.parent.postMessage({
        method: 'setSelectedCycle',
        args: {selectedCycle: selectedCycle}
    }, "*");
}

window.addEventListener("message", onNewPostMessageFromParent, false);

function onNewPostMessageFromParent(event) {
    if (event.data.method && subscribeAbleEvents.hasOwnProperty(event.data.method)) {
        subscribeAbleEvents[event.data.method](event.data);
    }
}

const subscribeAbleEvents = {
    "sendCycleDataToChild": sendCycleDataToChild,
    "sendApiGatewayResponse": sendApiGatewayResponse,
    "sendOverviewResponse": sendOverviewResponse,
    "sendCapabilityResponse": sendCapabilityResponse,
    "sendDocumentURL": sendDocumentURL,
    "sendLocaleResponse": sendChildData,
    "sendDarkModeStatus": sendDarkModeStatus,
    "sendFeatureStatus": sendFeatureStatus
};

function sendDarkModeStatus(data) {
    if (data.childData.capability === DARK_MODE.DARK) {
        setCurrentDarkMode(DARK_MODE.DARK);
    } else {
        setCurrentDarkMode(DARK_MODE.LIGHT);
    }
}

function sendCycleDataToChild(data) {
    if(postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendCapabilityResponse(data) {
    if(postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendApiGatewayResponse(data) {
    if(postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function sendOverviewResponse(data) {
    if(postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function sendDocumentURL(data) {
    if(postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function sendChildData(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

/**
 * Sends the feature status data to the corresponding promise resolver.
 */
function sendFeatureStatus(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}



// WEBPACK FOOTER //
// ./src/components/handler/ParentDataHandler.js